document.addEventListener("DOMContentLoaded", function () {
    gsap.set('.co-blog-s2-img.z-ani-o', { opacity: 0, y: 20, x: 5 });
    gsap.set('.co-blog-s2-text .z-ani-o', { opacity: 0, y: 40 });
    let cBS2Tl1 = gsap.timeline({ paused: true });
    cBS2Tl1.to('.co-blog-s2-img.z-ani-o', {
        y: 0,
        x: 0,
        opacity: 1,
        duration: 1,
        ease: "power2.inOut"
    });
    cBS2Tl1.to('.co-blog-s2-text .z-ani-o', {
        y: 0,
        scale: 1,
        opacity: 1,
        duration: 1,
        stagger: 0.2,
        ease: "power2.inOut"
    }, "-=0.9");
    ScrollTrigger.create({
        trigger: '.co-blog-s2-text .z-ani-o',
        start: "40% bottom",
        end: "bottom top",
        animation: cBS2Tl1
    });
});